import * as React from 'react';

type DownLoadLogoProps = { className: string };
type WixLogoProps = { rootClass: string; dotClass: string };
type WixNewLogoProps = { className: string };

export const DownloadLogo: React.FC<DownLoadLogoProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 177.32 142.49">
    <defs>
      <style>
        {
          '.cls-1{fill:none;stroke:#9d288c;stroke-miterlimit:10;stroke-width:13px}'
        }
      </style>
    </defs>
    <title>Artboard 1</title>
    <path
      className="cls-1"
      d="M28.66 65.5V104s0 14.5 13 14.5h94.5s12.5-.5 12.5-13.5V65.5"
    />
    <path className="cls-1" d="M90.11 89.76v-75m-23 50.5l22 24.5 24-24" />
  </svg>
);

export const WixLogo: React.FC<WixLogoProps> = ({ rootClass, dotClass }) => (
  <svg className={rootClass} viewBox="0 0 28 10.89" aria-label="wix">
    <path
      d="M16.02.2c-.55.3-.76.78-.76 2.14a2.17 2.17 0 0 1 .7-.42 3 3 0 0 0 .7-.4A1.62 1.62 0 0 0 17.22 0a3 3 0 0 0-1.18.2z"
      className={dotClass}
    ></path>
    <path d="M12.77.52a2.12 2.12 0 0 0-.58 1l-1.5 5.8-1.3-4.75a4.06 4.06 0 0 0-.7-1.55 2.08 2.08 0 0 0-2.9 0 4.06 4.06 0 0 0-.7 1.55L3.9 7.32l-1.5-5.8a2.12 2.12 0 0 0-.6-1A2.6 2.6 0 0 0 0 .02l2.9 10.83a3.53 3.53 0 0 0 1.42-.17c.62-.33.92-.57 1.3-2 .33-1.33 1.26-5.2 1.35-5.47a.5.5 0 0 1 .34-.4.5.5 0 0 1 .4.5c.1.3 1 4.2 1.4 5.5.4 1.5.7 1.7 1.3 2a3.53 3.53 0 0 0 1.4.2l2.8-11a2.6 2.6 0 0 0-1.82.53zm4.43 1.26a1.76 1.76 0 0 1-.58.5c-.26.16-.52.26-.8.4a.82.82 0 0 0-.57.82v7.36a2.47 2.47 0 0 0 1.2-.15c.6-.3.75-.6.75-2V1.8zm7.16 3.68L28 .06a3.22 3.22 0 0 0-2.3.42 8.67 8.67 0 0 0-1 1.24l-1.34 1.93a.3.3 0 0 1-.57 0l-1.4-1.93a8.67 8.67 0 0 0-1-1.24 3.22 3.22 0 0 0-2.3-.43l3.6 5.4-3.7 5.4a3.54 3.54 0 0 0 2.32-.48 7.22 7.22 0 0 0 1-1.16l1.33-1.9a.3.3 0 0 1 .57 0l1.37 2a8.2 8.2 0 0 0 1 1.2 3.47 3.47 0 0 0 2.33.5z"></path>
  </svg>
);

export const WixLogoNew: React.FC<WixNewLogoProps> = ({ className }) => (
  <svg
    className={className}
    width="60"
    height="20"
    viewBox="0 0 39 15"
    fill="none"
    aria-label="wix"
  >
    <g clipPath="url(#clip0_36_214)">
      <path
        d="M38.9999 0H36.8456C36.248 0 35.6894 0.280264 35.3538 0.74896L32.4728 4.77402C32.396 4.88076 32.2297 4.88076 32.1529 4.77402L29.2719 0.74896C28.9369 0.280264 28.3777 0 27.7801 0H25.6258L30.7581 7.16998L25.6541 14.3H27.8084C28.406 14.3 28.9646 14.0197 29.3002 13.551L32.1529 9.56593C32.2297 9.45919 32.396 9.45919 32.4728 9.56593L35.3254 13.551C35.6604 14.0197 36.2196 14.3 36.8172 14.3H38.9715L33.8676 7.16998L38.9999 0Z"
        fill="black"
      />
      <path
        d="M21.193 1.46274V14.3H22.2226C23.0758 14.3 23.7673 13.6453 23.7673 12.8373V0H22.7377C21.8844 0 21.193 0.654743 21.193 1.46274Z"
        fill="black"
      />
      <path
        d="M19.3054 0H18.3892C17.3804 0 16.5063 0.660706 16.2828 1.59214L14.233 10.1259L12.4389 2.15982C12.1071 0.68754 10.512 -0.305308 8.87973 0.121646C7.84005 0.393561 7.06927 1.22541 6.84446 2.22422L5.06864 10.1151L3.02267 1.59273C2.79849 0.661302 1.92443 0 0.915617 0H0L3.43388 14.2994H4.73489C5.91562 14.2994 6.93577 13.5176 7.18199 12.424L9.37721 2.66787C9.40429 2.54682 9.5189 2.45916 9.64925 2.45916C9.7796 2.45916 9.89421 2.54682 9.92129 2.66787L12.1184 12.4246C12.3646 13.5182 13.3848 14.2994 14.5655 14.2994H15.8709L19.3054 0Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_36_214">
        <rect width="39" height="14.3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ChevronRight = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.78559 9.5144C3.65912 9.38792 3.64762 9.19001 3.7511 9.05054L3.78559 9.01059L7.09602 5.7L3.78559 2.3894C3.65912 2.26293 3.64762 2.06501 3.7511 1.92555L3.78559 1.88559C3.91207 1.75911 4.10999 1.74762 4.24945 1.8511L4.28941 1.88559L8.10381 5.7L4.28941 9.5144C4.15028 9.65352 3.92472 9.65352 3.78559 9.5144Z"
      fill="#000624"
    />
  </svg>
);
